// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cYto","newExpiryDate":"styles_newExpiryDate__1ni4M","footer":"styles_footer__fFBjh"};